import { useMemo } from 'react';
import { convertUtcToFormattedTime } from '../../../util/AppUtils';
import ShowLightText from '../../../common/SmallButUseFull/ShowLightText';
import UnderlineUser from '../../../common/SmallButUseFull/UnderlineUser';

/**
 * Custom hook to generate "Current Status" text for revision
 * 
 * This hook generates text showing the last status change of the revision
 * including when it was changed and by whom.
 * 
 * @param {Object} currentRevision - The current revision object
 * @returns {string|null} The formatted current status text or null
 */
const useRevisionCurrentText = (currentRevision, disabled = false) => {
  const currentText = useMemo(() => {
    if (!currentRevision) {
      return null;
    }

    // Find the latest status change
    const status = currentRevision.status_changes?.find((s) => s.is_latest);
    let pendingApprovals = false;
    if(status?.status_changed_to === "Submitted For Approval"){
      // console.log("currentRevision.status_changes", currentRevision.status_changes);
      const data = JSON.parse(JSON.stringify(currentRevision.status_changes)).sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));
      const latestStatusIndex = data.findIndex(s=>s.status_changed_to === "Submitted For Approval");
      if(latestStatusIndex > 0){
        const previousStatus = data[latestStatusIndex - 1];
        if(previousStatus?.status_changed_to !== "Change Requested" 
          && currentRevision.status_changes.find(s=>s.status_changed_to === "Submitted For Approval").length > 1){
          pendingApprovals = true;
        }
      }
    }
    
    if (!status) {
      return null;
    }

    const user = status.audit_trail?.user;
    const statusLabel = status?.status_changed_to === "Not Submitted"
      ? "Created"
      : status?.status_changed_to;

    // Build user name safely
    const userName = user 
      ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
      : '';

    return (
      <ShowLightText
        text={
          <>
            Last {pendingApprovals ? "Approved" : statusLabel} on {convertUtcToFormattedTime(status.created_at)}{" "}
            {userName && <UnderlineUser name={userName} disabled={disabled} />}
          </>
        }
      />
    );
  }, [currentRevision, disabled]);
  

  return currentText;
};

export default useRevisionCurrentText;

